export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.08 50.09">
    <path d="M25 50.09a25 25 0 1 1 25-25 25.06 25.06 0 0 1-25 25zm0-48a22.92 22.92 0 1 0 23 22.96A22.94 22.94 0 0 0 25 2.13z" />
    <path d="M37 35.08h-5.3v-7.75c0-2-.83-3.41-2.65-3.41a2.69 2.69 0 0 0-2.53 1.84 3.32 3.32 0 0 0-.08 1.24v8.09h-5.25s.07-13.71 0-15h5.25v2.35c.31-1 2-2.49 4.66-2.49 3.32.05 5.9 2.17 5.9 6.81v8.32zM15.88 18.25a2.61 2.61 0 1 1 .07-5.2 2.61 2.61 0 1 1 0 5.2m2.45 16.83h-4.74v-15h4.67z" />
  </svg>
);
